module.exports = __webpack_public_path__ + "static/media/card.c973455b.png";